<div class="category-chips" *transloco="let t; prefix: 'products.badges'">
    @for (badge of badges; track badge) {
        <mat-chip disabled>{{ translate ? t(badge.toLowerCase()) : badge }}</mat-chip>
    }
</div>
